export async function optimiseAssignments(
    items,
    availableRooms
) {
    const response = await fetch(
        "https://us-central1-figure-it-out-app.cloudfunctions.net/memoryPalace",
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                type: "optimise",
                items,
                rooms: availableRooms
            })
        }
    );

    return await response.json();
}